const exhaustiveCheck = (_: never): never => {
  throw new Error("This error shouldn't occur.", _)
}

export default exhaustiveCheck
